import { useEffect, useRef } from 'react';
import { initValidate } from '../helpers/validate';

type props = {
  id: string
  children: React.ReactNode
  submitForm: (formEl: HTMLFormElement | null) => void
  className: string
}

export function FormValidate ({ id, children, submitForm, className }: props) {
  const formEl = useRef(null)

  useEffect(() => {
    if (!formEl.current) return
    const validate = initValidate(formEl.current)
    if (!validate) return
    validate.onSuccess((event) => {
      event && event.preventDefault()
      submitForm(formEl.current)
    })
  }, [formEl]);

  return (
    <form ref={formEl} id={id} className={className}>
      {children}
    </form>
  )
}
